import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';
import { useSettingsContext } from '../contexts/settings';
import Select from './filters/Select';

const Filters = () => {
	const { tax } = useFiltersContext();
	const settings = useSettingsContext();

	const taxEntries = Object.entries(tax);
	if (taxEntries.length && settings.filtersToShow.length) {
		return (
			<div className="pfa-filters">
				<div className="pfa-filters__tax">
					<div className="pfa-filters__tax-list">
						{taxEntries.map(([key, taxonomy]) => {
							if (settings.filtersToShow.includes(taxonomy.name)) {
								return <Select taxonomy={taxonomy} key={key} />;
							}
							return '';
						})}
					</div>
				</div>
			</div>
		);
	}

	return '';
};

Filters.displayName = 'Filters';

export default Filters;
